define(function () {
	var base_collection = require('./nearest_collection_base');

	return base_collection.extend({
		siteType: 'asset',
		urlRoot: '/delegate/civics-api/api/assetmanagement/assets/assettypeid/{4}?MapExtent={Min:{X:{0},Y:{1}},Max:{X:{2},Y:{3}}}',
		url: function () {
			//this.assetTypeName = this.assetType == 12 ? 'waterHydrant' : this.assetType == 86 ? 'complex' : 'building';
			let url = base_collection.prototype.url.apply(this, arguments);
			//the first 4 elements were already replaced via the prototype URL applying the extent.
			url = url.format(null, null, null, null, this.assetType);
			return url;
		},
		parse: function (response) {
			
			let data = response.data;
			data.forEach(asset => {
				//the asset service sets the type as the asset type, but we use type as the site type, like address, parcel, asset, etc
				asset.assetType = asset.type;
				asset.type = 'asset';
				//asset.locationLine1 = asset.assetId;
				
			});
			data = base_collection.prototype.parse.apply(this, [{data:data}]);
			
			return data;
		}
	});
});
